export default "__VITE_ASSET__dyZpQ96s__"